// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s5z4u","importantInfo":"styles_importantInfo__23yh0"};